(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const EVENT_REFRESH = 'cart-drawer:section-refresh';
    const EVENT_REFRESH_COMPLETE = 'cart-drawer:section-refresh-complete';
    const EVENT_REMOVE = 'cart-drawer:remove';
    const EVENT_REMOVE_COMPLETE = 'cart-drawer:remove-complete';
    const EVENT_QTY_CHANGE = 'cart-drawer:quantity-change';
    const EVENT_QTY_CHANGE_COMPLETE = 'cart-drawer:quantity-change-complete';
    const EVENT_ITEM_ADDED = 'cart:item-added';

    if (window.__tfCartDrawerSectionBridge) return;
    window.__tfCartDrawerSectionBridge = true;

    function getRoot() {
      return typeof window.Shopify !== 'undefined' && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';
    }

    function findDrawer() {
      return document.querySelector('[data-cart-drawer]');
    }

    function syncHeaderCartCount(count) {
      const n = Math.max(0, Number(count) || 0);
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        if (n > 0) {
          el.textContent = String(n);
          el.removeAttribute('hidden');
        } else {
          el.textContent = '';
          el.setAttribute('hidden', '');
        }
        el.setAttribute('aria-hidden', 'true');
      });

      document.querySelectorAll('[data-header-bag]').forEach(function (el) {
        const base = el.getAttribute('data-cart-label') || 'Bag';
        el.setAttribute('aria-label', n > 0 ? base + ' (' + n + ')' : base);
      });
    }

    async function fetchCartItemCount() {
      const response = await fetch(getRoot() + 'cart.js', {
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      });
      if (!response.ok) throw new Error('Cart fetch failed');
      const cart = await response.json();
      return cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
    }

    function getSectionId(drawer) {
      return (
        (drawer && drawer.getAttribute('data-cart-drawer-section-id')) ||
        (findDrawer() && findDrawer().getAttribute('data-cart-drawer-section-id')) ||
        ''
      );
    }

    function signalAsyncComplete(drawer) {
      const target = drawer || findDrawer();
      if (!target) return;
      target.dispatchEvent(new CustomEvent(EVENT_REMOVE_COMPLETE, { bubbles: true }));
      target.dispatchEvent(new CustomEvent(EVENT_QTY_CHANGE_COMPLETE, { bubbles: true }));
    }

    function openDrawerAnimated() {
      const drawer = findDrawer();
      if (!drawer) return;

      // Ensure a closed paint before adding --open so CSS transform can transition.
      drawer.classList.remove('ui-cart-drawer--open');
      drawer.setAttribute('aria-hidden', 'true');

      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          const target = findDrawer();
          if (!target) return;
          target.classList.add('ui-cart-drawer--open');
          target.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';
          target.dispatchEvent(new CustomEvent('cart-drawer:open', { bubbles: true }));
          target.dispatchEvent(
            new CustomEvent('drawer:open', {
              bubbles: true,
              detail: { blockName: 'ui-cart-drawer' },
            }),
          );
        });
      });
    }

    function applyOpenState(html, shouldOpen) {
      if (!shouldOpen) return html;

      const template = document.createElement('template');
      template.innerHTML = html.trim();
      const sectionEl = template.content.firstElementChild;
      if (!sectionEl) return html;

      const drawer = sectionEl.querySelector('[data-cart-drawer]') || sectionEl;
      if (!drawer || !drawer.classList) return html;

      const classes = drawer.getAttribute('class') || '';
      if (!/\bui-cart-drawer--open\b/.test(classes)) {
        drawer.setAttribute('class', (classes + ' ui-cart-drawer--open').trim());
      }
      drawer.setAttribute('aria-hidden', 'false');

      return sectionEl.outerHTML;
    }

    async function refreshSection(detail) {
      const drawer = findDrawer();
      const sectionId = (detail && detail.sectionId) || getSectionId(drawer);
      if (!sectionId) {
        document.dispatchEvent(new CustomEvent(EVENT_REFRESH_COMPLETE, { bubbles: true }));
        signalAsyncComplete(drawer);
        return;
      }

      const preserveOpen =
        detail && Object.prototype.hasOwnProperty.call(detail, 'open') ? Boolean(detail.open) : true;
      const wasOpen =
        preserveOpen &&
        drawer &&
        (drawer.classList.contains('ui-cart-drawer--open') ||
          drawer.getAttribute('aria-hidden') === 'false');

      try {
        const response = await fetch(
          getRoot() + '?sections=' + encodeURIComponent(sectionId),
        );
        if (!response.ok) throw new Error('Section fetch failed');
        const payload = await response.json();
        const html = payload[sectionId];
        if (!html) throw new Error('Missing section HTML');

        const sectionEl = document.getElementById('shopify-section-' + sectionId);
        if (!sectionEl) throw new Error('Missing section node');

        sectionEl.outerHTML = applyOpenState(html, wasOpen || preserveOpen);

        const nextDrawer = findDrawer();
        document.dispatchEvent(
          new CustomEvent(EVENT_REFRESH_COMPLETE, {
            bubbles: true,
            detail: { sectionId, open: wasOpen || preserveOpen },
          }),
        );
        signalAsyncComplete(nextDrawer);
      } catch (error) {
        console.error('[cart-drawer] section refresh failed', error);
        document.dispatchEvent(
          new CustomEvent(EVENT_REFRESH_COMPLETE, {
            bubbles: true,
            detail: { sectionId, error: true },
          }),
        );
        signalAsyncComplete(drawer);
      }
    }

    async function removeLine(detail) {
      const lineKey = detail && detail.lineKey ? String(detail.lineKey).trim() : '';
      const drawer = findDrawer();

      if (!lineKey) {
        signalAsyncComplete(drawer);
        return;
      }

      try {
        const response = await fetch(getRoot() + 'cart/change.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({ id: lineKey, quantity: 0 }),
        });
        if (!response.ok) throw new Error('Cart change failed (' + response.status + ')');
        const cart = await response.json().catch(function () {
          return null;
        });
        if (cart && typeof cart.item_count === 'number') {
          syncHeaderCartCount(cart.item_count);
        }
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        await refreshSection({ open: true });
      } catch (error) {
        console.error('[cart-drawer] remove failed', error);
        signalAsyncComplete(drawer);
      }
    }

    async function changeQuantity(detail) {
      const lineKey = detail && detail.lineKey ? String(detail.lineKey).trim() : '';
      const quantity =
        detail && typeof detail.quantity === 'number' ? Math.max(0, Math.floor(detail.quantity)) : null;
      const drawer = findDrawer();

      if (!lineKey || quantity === null) {
        signalAsyncComplete(drawer);
        return;
      }

      try {
        const response = await fetch(getRoot() + 'cart/change.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({ id: lineKey, quantity: quantity }),
        });
        if (!response.ok) throw new Error('Cart change failed (' + response.status + ')');
        const cart = await response.json().catch(function () {
          return null;
        });
        if (cart && typeof cart.item_count === 'number') {
          syncHeaderCartCount(cart.item_count);
        }
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        await refreshSection({ open: true });
      } catch (error) {
        console.error('[cart-drawer] quantity change failed', error);
        signalAsyncComplete(drawer);
      }
    }

    document.addEventListener(EVENT_REFRESH, function (event) {
      void refreshSection((event && event.detail) || {});
    });

    document.addEventListener(EVENT_REMOVE, function (event) {
      void removeLine((event && event.detail) || {});
    });

    document.addEventListener(EVENT_QTY_CHANGE, function (event) {
      void changeQuantity((event && event.detail) || {});
    });

    document.addEventListener(EVENT_ITEM_ADDED, function () {
      void (async function () {
        try {
          const count = await fetchCartItemCount();
          syncHeaderCartCount(count);

          const drawer = findDrawer();
          if (!drawer) return;

          const alreadyOpen = Boolean(
            drawer.classList.contains('ui-cart-drawer--open') ||
              drawer.getAttribute('aria-hidden') === 'false',
          );

          if (alreadyOpen) {
            await refreshSection({ open: true });
            document.body.style.overflow = 'hidden';
            return;
          }

          // Refresh closed, wait a paint, then open so the slide transition can run.
          await refreshSection({ open: false });
          await new Promise(function (resolve) {
            window.requestAnimationFrame(function () {
              window.requestAnimationFrame(resolve);
            });
          });
          openDrawerAnimated();
        } catch (error) {
          console.error('[cart-drawer] open after add-to-cart failed', error);
        }
      })();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collections"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const SPY_ATTR = 'data-collection-list-spy';
    const ACTIVE_CLASS = 'ui-collection-list__index-link--active';
    const BOTTOM_TOLERANCE = 2;
    const ROW_TOLERANCE = 2;
    const REACH_OFFSET = 80;
    const SCROLL_IDLE_MS = 150;
    const JUMP_START_MS = 1000;

    function init(root) {
      if (root.hasAttribute(SPY_ATTR)) return;
      const nav = root.querySelector('[data-collection-list-index]');
      if (!nav) return;
      const list = nav.querySelector('ol');
      const links = Array.from(nav.querySelectorAll('a.ui-collection-list__index-link'));
      const entries = links
        .map(function (link) {
          const id = decodeURIComponent((link.getAttribute('href') || '').slice(1));
          const group = id ? document.getElementById(id) : null;
          return group ? { link: link, group: group } : null;
        })
        .filter(Boolean);
      if (entries.length === 0) return;

      let active = null;
      let clicked = null;
      let ticking = false;
      let jumping = false;
      let idleTimer = null;

      function revealInBar(link) {
        if (!list || list.scrollWidth <= list.clientWidth) return;
        const linkLeft = link.offsetLeft - list.offsetLeft;
        const linkRight = linkLeft + link.offsetWidth;
        if (linkLeft < list.scrollLeft) {
          list.scrollTo({ left: linkLeft, behavior: 'smooth' });
        } else if (linkRight > list.scrollLeft + list.clientWidth) {
          list.scrollTo({ left: linkRight - list.clientWidth, behavior: 'smooth' });
        }
      }

      function setActive(entry) {
        if (entry === active) return;
        if (active) {
          active.link.classList.remove(ACTIVE_CLASS);
          active.link.removeAttribute('aria-current');
        }
        active = entry;
        active.link.classList.add(ACTIVE_CLASS);
        active.link.setAttribute('aria-current', 'location');
        revealInBar(active.link);
      }

      // Groups share a row in the two-column layout; keep the current letter while its
      // row is the one in view, otherwise take the first group of the reached row.
      function update() {
        ticking = false;
        if (jumping) return;
        const threshold = nav.getBoundingClientRect().bottom + REACH_OFFSET;
        const atBottom =
          window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - BOTTOM_TOLERANCE;

        let rowTop = null;
        let rowFirst = entries[0];
        for (const entry of entries) {
          const top = entry.group.getBoundingClientRect().top;
          if (top > threshold && !atBottom) break;
          if (rowTop === null || Math.abs(top - rowTop) > ROW_TOLERANCE) {
            rowTop = top;
            rowFirst = entry;
          }
        }

        if (active && rowTop !== null) {
          const activeTop = active.group.getBoundingClientRect().top;
          if (Math.abs(activeTop - rowTop) <= ROW_TOLERANCE) return;
          const activeOnScreen =
            activeTop >= nav.getBoundingClientRect().bottom && activeTop < window.innerHeight;
          if (atBottom && active === clicked && activeOnScreen) return;
        }
        setActive(rowFirst);
      }

      function requestUpdate() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      }

      // A click scrolls smoothly past earlier rows; hold the clicked letter until it settles.
      function endJump() {
        window.clearTimeout(idleTimer);
        if (!jumping) return;
        jumping = false;
        requestUpdate();
      }

      function endJumpWhenIdle(delay) {
        window.clearTimeout(idleTimer);
        idleTimer = window.setTimeout(endJump, delay || SCROLL_IDLE_MS);
      }

      function onScroll() {
        if (jumping) {
          endJumpWhenIdle();
          return;
        }
        clicked = null;
        requestUpdate();
      }

      links.forEach(function (link) {
        link.addEventListener('click', function () {
          const entry = entries.find(function (e) {
            return e.link === link;
          });
          if (!entry) return;
          jumping = true;
          clicked = entry;
          setActive(entry);
          endJumpWhenIdle(JUMP_START_MS);
        });
      });

      root.setAttribute(SPY_ATTR, '');
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('scrollend', endJump);
      window.addEventListener('resize', requestUpdate);
      update();
    }

    function initAll() {
      document.querySelectorAll('[data-collection-list]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-feed"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const TEMPLATE_SELECTOR = 'template[data-social-feed-embed-template]';
    const ROOT_MARGIN = '600px 0px';

    // Scripts cloned from a <template> never run; recreate them so the embed executes.
    function mount(template) {
      const fragment = template.content.cloneNode(true);
      fragment.querySelectorAll('script').forEach(function (inert) {
        const script = document.createElement('script');
        Array.from(inert.attributes).forEach(function (attr) {
          script.setAttribute(attr.name, attr.value);
        });
        script.async = false;
        script.textContent = inert.textContent;
        inert.replaceWith(script);
      });
      template.replaceWith(fragment);
    }

    function initAll() {
      const templates = Array.from(document.querySelectorAll(TEMPLATE_SELECTOR));
      if (templates.length === 0) return;

      if (!('IntersectionObserver' in window)) {
        templates.forEach(mount);
        return;
      }

      const observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            observer.unobserve(entry.target);
            const template = entry.target.querySelector(TEMPLATE_SELECTOR);
            if (template) mount(template);
          });
        },
        { rootMargin: ROOT_MARGIN }
      );

      templates.forEach(function (template) {
        observer.observe(template.parentElement);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
